// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------

Shopify.getProduct = function (handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if (typeof callback === 'function') {
      callback(product);
    } else {
      Shopify.onProduct(product);
    }
  });
};

// ---------------------------------------------------------
// Custom JS for setting up product form on blog page
// ---------------------------------------------------------

$(document).ready(function() {
  $(".product-handle").each((ix, em) => {
    let currentProductHandle = $(em).text().trim();
    if (currentProductHandle) {
      $.get(`/products/${currentProductHandle}?view=en-product-view-article`, (data) => {
        $(em).html(data).fadeIn(0);
      }).fail((jqXHR, textStatus, errorThrown) => {
        console.error("Error loading product: ", textStatus, errorThrown);
      });
    }
  });
});


